import * as React from "react";
import BasePoliciesMissingData from "../../features/policies/routes/policies-missing-data";
import { InsuranceType } from "../../constants";
import { PHASE } from "../../routeConfig";
import useUnlinkedApplicationEntryRoute from "../../features/unlinked-application/useUnlinkedApplicationEntryRoute";
export default function HomePoliciesMissingData() {
    var continueRoute = useUnlinkedApplicationEntryRoute(InsuranceType.Home);
    return (React.createElement(BasePoliciesMissingData, { continueRoute: continueRoute, backRoute: PHASE.HOME_SELECT_ISSUER }));
}
